import { RECEIVE_CATEGORIES } from '../actions'

export const DEFAULT_CATEGORIES = 'defaultCategories'

let defaultCategories = [{
        id: '',
        name: '',
    }]

let defaultState = {
    [DEFAULT_CATEGORIES]: defaultCategories
}

export default function categories(state = defaultState, action) {
    switch(action.type) {        
        case RECEIVE_CATEGORIES:
            const { categories } = action.payload
            return Object.assign({}, state, {
                categories: categories
            });

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/categories.js